{
  "version": 1,
  "asset_id": "b6b0e991-7cd4-445a-84ce-e7f1dee158d6",
  "project_id": "9fb22223-732b-4b0d-9eac-b115ce8cfd9c",
  "url": "/__l5e/assets-v1/b6b0e991-7cd4-445a-84ce-e7f1dee158d6/supabase.svg",
  "r2_key": "a/v1/9fb22223-732b-4b0d-9eac-b115ce8cfd9c/b6b0e991-7cd4-445a-84ce-e7f1dee158d6/supabase.svg",
  "original_filename": "supabase.svg",
  "size": 5806,
  "content_type": "image/svg+xml",
  "created_at": "2026-06-16T14:53:50Z"
}
